import { render } from "./AboutUs.vue?vue&type=template&id=78c970f6&scoped=true&ts=true"
import script from "./AboutUs.vue?vue&type=script&lang=ts"
export * from "./AboutUs.vue?vue&type=script&lang=ts"

import "./AboutUs.vue?vue&type=style&index=0&id=78c970f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78c970f6"]])

export default __exports__